export function getPreLeadReason(prelead) {
  if (!prelead) return '';
  return String(prelead.reason ?? '').trim();
}

export function isPreleadSettled(prelead) {
  return prelead?.lead_id != null || prelead?.is_disqualified === true;
}

export function getPreLeadLegacyLog(preleadOrNotes) {
  if (!preleadOrNotes) return '';
  const legacy =
    preleadOrNotes.legacy_log ??
    preleadOrNotes.legacyLog ??
    preleadOrNotes.log ??
    preleadOrNotes.telecalling_log ??
    null;
  return typeof legacy === 'string' ? legacy.trim() : '';
}

export function hasPreleadNotes(prelead) {
  if (!prelead) return false;

  const notesCount = Number(prelead.notes_count ?? prelead.notesCount ?? prelead.total ?? 0);
  if (notesCount > 0) return true;
  if (getPreLeadLegacyLog(prelead)) return true;
  if (getPreLeadLogs(prelead).length > 0) return true;

  return false;
}

export function hasPreleadNoteToView(prelead) {
  if (isPreleadSettled(prelead)) {
    return Boolean(getPreLeadReason(prelead) || hasPreleadNotes(prelead));
  }
  return hasPreleadNotes(prelead);
}

export function getPreLeadLog(prelead) {
  if (!prelead) return '';
  if (typeof prelead === 'string') return prelead.trim();

  const legacy = getPreLeadLegacyLog(prelead);
  if (legacy) return legacy;

  const logs = getPreLeadLogs(prelead);
  return logs.length > 0 ? getPreLeadLogText(logs[0]) : '';
}

export function getPreLeadLogs(preleadOrLogs) {
  if (!preleadOrLogs) return [];
  if (Array.isArray(preleadOrLogs)) return preleadOrLogs;

  const notes = preleadOrLogs.notes;
  if (Array.isArray(notes) && notes.length > 0) return notes;

  const direct = preleadOrLogs.log ?? preleadOrLogs.telecalling_log;
  if (typeof direct === 'string' && direct.trim()) {
    return [
      {
        log: direct.trim(),
        updated_at: preleadOrLogs.updated_at ?? preleadOrLogs.updatedAt ?? null
      }
    ];
  }

  const raw =
    preleadOrLogs.logs ??
    preleadOrLogs.pre_lead_logs ??
    preleadOrLogs.PreLeadLogs ??
    preleadOrLogs.preLeadLogs ??
    [];
  return Array.isArray(raw) ? raw : [];
}

export function getPreLeadLogText(entry) {
  return String(
    entry?.note ?? entry?.log ?? entry?.message ?? entry?.description ?? entry?.text ?? ''
  ).trim();
}

export function getPreLeadLogAuthor(entry) {
  const user =
    entry?.user ??
    entry?.User ??
    entry?.added_by ??
    entry?.addedBy ??
    entry?.created_by ??
    entry?.createdBy ??
    null;
  if (!user) return '—';
  if (typeof user === 'string') return user.trim() || '—';
  return String(user.name ?? user.full_name ?? user.email ?? '—').trim() || '—';
}

export function getPreLeadLogDate(entry) {
  return entry?.created_at ?? entry?.createdAt ?? entry?.updated_at ?? entry?.updatedAt ?? null;
}

export function sortPreLeadLogsNewestFirst(logs) {
  return [...getPreLeadLogs(logs)].sort((a, b) => {
    const ta = new Date(getPreLeadLogDate(a) ?? 0).getTime();
    const tb = new Date(getPreLeadLogDate(b) ?? 0).getTime();
    return tb - ta;
  });
}

export function formatPreLeadNoteDate(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return '';
  }
}
